import { gql } from 'apollo-angular';

/**
 * AdditionalOrderInformationTemplate schema
 */
export class AdditionalOrderInformationTemplateSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		uid
		id
		type
		name
		isActivated
		isMandatory
		position
		defaultValue
		possibleValues
	`;

	static readonly createAdditionalOrderInformationTemplate = gql`
		mutation CreateAdditionalOrderInformationTemplate($template: AdditionalOrderInformationTemplateInput!) {
			createAdditionalOrderInformationTemplate(template: $template){
				${AdditionalOrderInformationTemplateSchema.topLevelProperties}
			}
		}
	`;

	static readonly updateAdditionalOrderInformationTemplate = gql`
		mutation UpdateAdditionalOrderInformationTemplate($uid: ID!, $template: AdditionalOrderInformationTemplateInput!) {
			updateAdditionalOrderInformationTemplate(uid: $uid, template: $template){
				${AdditionalOrderInformationTemplateSchema.topLevelProperties}
			}
		}
	`;

	static readonly deleteAdditionalOrderInformationTemplate = gql`
		mutation DeleteAdditionalOrderInformationTemplate($uid: ID!) {
			deleteAdditionalOrderInformationTemplate(uid: $uid) {
				${AdditionalOrderInformationTemplateSchema.topLevelProperties}
			}
		}
	`;
}
